module.exports = __webpack_public_path__ + "static/media/monthlyPLAnalaysis_en_dark_large.379c8ac1.png";